/**
 * Enumeration for different content layouts of the `ui5-wizard`.
 * @public
 */
enum WizardContentLayout {
	/**
      * Display the content of the `ui5-wizard` as multiple steps in a scroll section.
	 * @public
     */
    MultipleSteps = "MultipleSteps",

	/**
      * Display the content of the `ui5-wizard` as single step.
	 * @public
     */
     SingleStep = "SingleStep",
}

export default WizardContentLayout;
